import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { getOnboardingSurvey } from '@/dataExchange/services/survey.service';
import useLoggedInUserData from '@/hooks/useUserData/useLoggedInUserData';
import { ROUTES } from '@/pages/Routing/Routing';
import { SSO_NAME_PLACEHOLDER } from '@/utils/constants/common';

const useOnboardingSurveyRedirect = () => {
    const { isCompanyOwner, firstName, lastName, organization } = useLoggedInUserData();
    const navigate = useNavigate();
    const checkedRef = useRef(false);

    const isUserDataLoaded = firstName !== undefined;
    const needsCompleteProfile =
        firstName === SSO_NAME_PLACEHOLDER ||
        lastName === SSO_NAME_PLACEHOLDER ||
        organization?.name === SSO_NAME_PLACEHOLDER;

    useEffect(() => {
        if (!isCompanyOwner || !isUserDataLoaded || needsCompleteProfile || checkedRef.current) return;
        checkedRef.current = true;

        getOnboardingSurvey().then(survey => {
            if (!survey || !survey.surveyCompleted) {
                navigate(ROUTES.REGISTRATION_SURVEY);
            }
        });
    }, [isCompanyOwner, isUserDataLoaded, needsCompleteProfile, navigate]);
};

export default useOnboardingSurveyRedirect;
